import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { isType } from '@sorare/core/src/lib/gql';

import { AnyTaskBasicClaimStory } from '#src/components/missions/AnyTaskBasicClaimStory/index.tsx';
import { DecisivePlayerPickerTaskClaimStory } from '#src/components/missions/DailyTask/DecisivePlayerPickerTaskClaimStory/index.tsx';
import { ThresholdsStreakTaskClaimStory } from '#src/components/missions/Streaks/ThresholdsStreakTaskClaimStory/index.tsx';
import { TaskTrckClaimStory } from '#src/components/missions/TaskTrckClaimStory/index.tsx';

import type { AnyTaskClaimStory_taskInterface } from './__generated__/index.graphql.ts';

type Props = {
  task: AnyTaskClaimStory_taskInterface;
  open?: boolean;
  onClose: () => void;
};
export const AnyTaskClaimStory = ({ task, open, onClose }: Props) => {
  if (!open) {
    return null;
  }

  if (isType(task, 'DecisivePlayerPickerTask')) {
    return task.parentTask ? (
      <TaskTrckClaimStory task={task} onClose={onClose} />
    ) : (
      <DecisivePlayerPickerTaskClaimStory task={task} onClose={onClose} />
    );
  }
  if (isType(task, 'ThresholdsStreakTask')) {
    return <ThresholdsStreakTaskClaimStory task={task} onClose={onClose} />;
  }

  return <AnyTaskBasicClaimStory task={task} onClose={onClose} />;
};

AnyTaskClaimStory.fragments = {
  taskInterface: gql`
    fragment AnyTaskClaimStory_taskInterface on TaskInterface {
      id
      ... on DecisivePlayerPickerTask {
        id
        parentTask {
          id
        }
      }
      ...DecisivePlayerPickerTaskClaimStory_decisivePlayerPickerTask
      ...ThresholdsStreakTaskClaimStory_thresholdsStreakTask
      ...AnyTaskBasicClaimStory_taskInterface
      ...TaskTrckClaimStory_decisivePlayerPickerTask
    }
    ${DecisivePlayerPickerTaskClaimStory.fragments.taskInterface}
    ${ThresholdsStreakTaskClaimStory.fragments.taskInterface}
    ${AnyTaskBasicClaimStory.fragments.taskInterface}
    ${TaskTrckClaimStory.fragments.taskInterface}
  ` as TypedDocumentNode<AnyTaskClaimStory_taskInterface>,
};
